/**
 * Shared tab-open helper for the dashboard entry points (main toolbar,
 * command palette, later the S23 explorer node). Focuses an existing
 * dashboard tab instead of stacking duplicates; `dashboardId: null` lets
 * DashboardTab resolve the most-recent dashboard (or the zero state).
 */
import { useWorkspaceStore } from '../../core/store/workspaceStore';

export function openDashboardTab(dashboardId: string | null = null): string {
  const { tabs, addTab, setActiveTab, updateTabContent } = useWorkspaceStore.getState();
  const existing = tabs.find((t) => t.type === 'dashboard');
  if (existing) {
    if (dashboardId) updateTabContent<'dashboard'>(existing.id, { dashboardId });
    setActiveTab(existing.id);
    return existing.id;
  }
  return addTab({ title: 'Dashboards', type: 'dashboard', content: { dashboardId } });
}
